<div [class.__legend-horizontal]="direction === directions.Horizontal">
    <p appColorBullet [color]="color" [innerHtml]="label | translate" class="__legend-label"></p>
    <ng-container *ngIf="!!sub">
        <div class="__legend-sub u-font-size-small u-color-muted" [innerHtml]="sub | translate"></div>
    </ng-container>
</div>
